export const supervisorScreenMessagesEn = {
  'supervisorScreen.sidebar.viewOptions.filterBy.title': 'Filter by',
  'supervisorScreen.sidebar.viewOptions.filterBy.label': 'Note type',
  'supervisorScreen.sidebar.viewOptions.groupBy.title': 'Group by',
  'supervisorScreen.sidebar.viewOptions.groupBy.none': 'None',
  'supervisorScreen.sidebar.viewOptions.groupBy.type': 'Type',
  'supervisorScreen.sidebar.viewOptions.groupBy.date': 'Date',
  'supervisorScreen.sidebar.viewOptions.sortBy.title': 'Sort by',
  'supervisorScreen.sidebar.viewOptions.sortBy.ascending': 'Ascending',
  'supervisorScreen.sidebar.viewOptions.sortBy.descending': 'Descending',
  'supervisorScreen.sidebar.viewOptions.title': 'View Options',
  'supervisorScreen.sidebar.viewOptions.collapseButtonLabel': 'Collapse',
  'supervisorScreen.sidebar.viewOptions.expandButtonLabel': 'Expand',

  'supervisorContent.breadcrumb.supervisorQueue': 'Encounters',
  'supervisorContent.breadcrumb.supervisor': 'Encounter-level annotation',
  'supervisorContent.noteSection.showAnnotationButton': 'Show annotations',
  'supervisorContent.noteSection.statusChip.pending': 'Pending review',
  'supervisorContent.noteSection.statusChip.conflicts_pending': 'Conflicts pending',
  'supervisorContent.noteSection.statusChip.draft': 'Draft',
  'supervisorContent.noteSection.statusChip.finalized': 'Finalized',
  'supervisorContent.noteSection.statusChip.supervisor_completed': 'Completed',
  'supervisorContent.noteSection.statusChip.completed': 'Completed',
  'supervisorContent.noteSection.statusChip.inreview': 'In review',
  'supervisorContent.noteSection.statusChip.active': 'Active',
  'supervisorContent.noteSection.statusChip.supervisor_complete': 'Supervisor complete',
  'supervisorContent.noteSection.statusChip.finalized_a1': 'Finalized by Annotator 1',
  'supervisorContent.noteSection.statusChip.finalized_a2': 'Finalized by Annotator 2',
  'supervisorContent.annotationConfig.title.info': 'TODO: add correct tooltip text',

  // Review annotations sidebar
  'supervisorReview.tab.annotator1': 'Annotator 1',
  'supervisorReview.tab.annotator2': 'Annotator 2',
  'supervisorReview.tab.supervisor': 'Supervisor',
  'supervisorReview.tab.annotationCount': 'Annotation #{count}',
  'supervisorReview.tab.inProgress.chip.title': 'In progress',
  'supervisorReview.tab.conflicts': 'Conflicts',
  'supervisorReview.tab.resolved': 'Finalized',
  'supervisorReview.conflictTab.annotator1': 'Annotator 1',
  'supervisorReview.conflictTab.annotator2': 'Annotator 2',
  'supervisorReview.resolvedTab.annotator1': 'Annotator 1',
  'supervisorReview.resolvedTab.annotator2': 'Annotator 2',
  'supervisorReview.resolvedTab.bothAnnotators': 'Both annotators',
  'supervisorReview.resolvedTab.addedBySupervisor': 'Supervisor',
  'supervisorReview.resolvedTab.accepted': 'Both annotators',
  'supervisorReview.conflictTab.noConflictsPending': 'No conflicts pending',
  'supervisorReview.conflictTab.button.acceptBoth': 'Accept both',
  'supervisorReview.conflictTab.button.rejectBoth': 'Reject both',
  'supervisorReview.conflictTab.button.reject': 'Reject',
  'supervisorReview.conflictTab.error.acceptFailed':
    'Failed to accept annotation. Please try again.',
  'supervisorReview.conflictTab.error.rejectFailed':
    'Failed to reject annotation. Please try again.',

  'supervisorReview.acceptAnnotationModal.title': 'Resolve conflict',
  'supervisorReview.acceptAnnotationModal.infoBox.title': 'Confirm resolution',
  'supervisorReview.acceptAnnotationModal.acceptAnnotator.button': 'Accept A{annotatorNumber}',
  'supervisorReview.acceptAnnotationModal.accept.button': 'Accept',
  'supervisorReview.acceptAnnotationModal.cancel.button': 'Cancel',
  'supervisorReview.acceptAnnotationModal.acceptLoading.message': 'Accepting the annotation',
  'supervisorReview.acceptAnnotationModal.description.annotator.message':
    "Accepting Annotator {annotatorNumber}'s annotation",
  'supervisorReview.acceptAnnotationModal.acceptAndDReject.description.annotator.message':
    "This action will accept Annotator {annotatorNumberToAccept}'s annotation and automatically reject Annotator {annotatorNumberToReject}'s annotation",
  'supervisorReview.acceptAnnotationModal.description.message': 'Accepting annotation',

  'supervisorReview.markAsCompleted.button': 'Mark encounter as completed',

  // Mark supervision task as complete modal
  'supervisorReview.markSupervisionTaskCompleteModal.title': 'Mark supervision task as complete',
  'supervisorReview.markSupervisionTaskCompleteModal.description':
    'Are you sure you want to mark this supervision task as complete?',
  'supervisorReview.markSupervisionTaskCompleteModal.finalizingMessage':
    'Marking task as complete...',
  'supervisorReview.markSupervisionTaskCompleteModal.confirmButton': 'Mark as complete',
  'supervisorReview.markSupervisionTaskCompleteModal.cancelButton': 'Cancel',
  'supervisorReview.annotatorTab.noAnnotations': 'Annotations not done yet!',
  'supervisorReview.finalizedTab.noAnnotations': 'No annotations finalized yet!',
};
